import {
    ProjectSettingsAction,
    ProjectSettingsType,
} from '../../actionTypes/settings/projectSettings';
import {
    getInitialProjectTypeSettingsState,
    IProjectTypeSettings,
} from '../../types';

const PROJECT_SETTINGS_INITIAL_STATE: IProjectTypeSettings =
    getInitialProjectTypeSettingsState();
const reducer = (
    state = {
        projectSettings: PROJECT_SETTINGS_INITIAL_STATE,
        restrictedIntakeIds: [],
    },
    action: ProjectSettingsAction
): {
    projectSettings: IProjectTypeSettings;
    restrictedIntakeIds: Array<string>;
} => {
    switch (action.type) {
        case ProjectSettingsType.SET_CURRENT_PROJECT_TYPE_SETTINGS:
            return action.payload;
        default:
            return state;
    }
};
export default reducer;
